// features/bookmarks/filterBookmarks.ts — pure list helpers (no React, no store).

import type { Bookmark, BookmarkFolder } from '@/core/models/bookmark';
import type { TypeFilter, SortId } from './meta';

/** AND-combine a type filter + folder filter, then sort by savedAt. */
export function filterBookmarks(
  list: Bookmark[],
  type: TypeFilter,
  folderId: string,
  sort: SortId,
): Bookmark[] {
  const filtered = list.filter(
    (b) =>
      (type === 'all' || b.type === type) &&
      (folderId === 'all' || b.folderId === folderId),
  );
  return [...filtered].sort((x, y) =>
    sort === 'recent' ? y.savedAt - x.savedAt : x.savedAt - y.savedAt,
  );
}

export interface Overview {
  total: number;
  folderCount: number;
  thisWeek: number;
  topFolder: { name: string; count: number };
}

/** Derive the overview-panel stats from the bookmarks + folders. */
export function deriveOverview(list: Bookmark[], folders: BookmarkFolder[]): Overview {
  let topFolder = { name: 'None', count: 0 };
  for (const f of folders) {
    const count = list.filter((b) => b.folderId === f.id).length;
    if (count > topFolder.count) topFolder = { name: f.name, count };
  }
  return {
    total: list.length,
    folderCount: folders.length,
    thisWeek: list.filter((b) => b.recent).length,
    topFolder,
  };
}

/** The N most-recently-saved bookmarks (savedAt desc). */
export function recentlySaved(list: Bookmark[], n: number): Bookmark[] {
  return [...list].sort((x, y) => y.savedAt - x.savedAt).slice(0, n);
}
